import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useAuth } from "../login/AuthProvider";
import { admin } from "../../components/apipath";

export default function TeacherChangePassword() {
  const { token } = useAuth();
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const onChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async () => {
    if (!form.old_password || !form.new_password) {
      return Swal.fire("錯誤", "請填寫舊密碼與新密碼", "error");
    }
    if (form.new_password !== form.confirm_password) {
      return Swal.fire("錯誤", "新密碼與確認新密碼不一致", "error");
    }

    try {
      const res = await axios.put(
        `${admin}self/password`,
        { old_password: form.old_password, new_password: form.new_password },
        { headers: { token } }
      );
      Swal.fire("成功", res.data.message || "密碼已更新", "success");
      setForm({ old_password: "", new_password: "", confirm_password: "" });
    } catch (err) {
      Swal.fire(
        "失敗",
        err.response?.data?.message || "更新失敗",
        "error"
      );
    }
  };

  return (
    <div className="container mt-4">
      <h3>修改密碼</h3>

      <div className="form-group">
        <label>舊密碼</label>
        <input
          type="password"
          name="old_password"
          className="form-control"
          value={form.old_password}
          onChange={onChange}
        />
      </div>

      <div className="form-group">
        <label>新密碼</label>
        <input
          type="password"
          name="new_password"
          className="form-control"
          value={form.new_password}
          onChange={onChange}
        />
      </div>

      <div className="form-group">
        <label>確認新密碼</label>
        <input
          type="password"
          name="confirm_password"
          className="form-control"
          value={form.confirm_password}
          onChange={onChange}
        />
      </div>

      <button className="btn btn-primary" onClick={submit}>
        更新密碼
      </button>
    </div>
  );
}
